import { Html } from '@mv/ui-kit/primitives';
import type { CtaTileLinkProps } from './CtaTileLink';

export function CtaTileLink({ href, onPress, accessibilityLabel, hrefAttrs, children }: CtaTileLinkProps) {
	return (
		<Html.A
			href={href}
			onPress={onPress}
			accessibilityLabel={accessibilityLabel}
			hrefAttrs={hrefAttrs}
			className="flex min-w-0 flex-col items-center justify-center gap-3 rounded-lg bg-black p-4 text-center no-underline transition-colors duration-300 web:w-full web:hover:bg-primary-hover web:min-[600px]:w-[calc(50%-0.25rem)]"
		>
			{children}
		</Html.A>
	);
}
